// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBCiqHKz0KwC8LYWN_wb4gGEz8Nxr8QNGs",
    authDomain: "bus.paaza.app",
    projectId: "paaza-app",
    storageBucket: "paaza-app.appspot.com",
    messagingSenderId: "918769756654",
    appId: "1:918769756654:web:18d2cbd8ac79aba7c946ff"
  },
  recaptcha3SiteKey: '6LdYsYsfAAAAAEoNNKrSkWJlXScYkD8cGrD6wcLY'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
